import { CreateMultiLegShippingEstimateByFuelResponse } from '@lune-climate/lune'
import LocalGasStationOutlinedIcon from '@mui/icons-material/LocalGasStationOutlined'
import OpacityOutlinedIcon from '@mui/icons-material/OpacityOutlined'

import { InputsWrapper } from './InputsWrapper'
import { ResultLabeledSectionAndTiles } from './ResultLabeledSectionAndTiles'

export const MultiLegShippingByFuelInputSection = ({
    estimateLeg,
    requestLeg,
}: {
    estimateLeg: CreateMultiLegShippingEstimateByFuelResponse['legs'][number]
    requestLeg: CreateMultiLegShippingEstimateByFuelResponse['request']['legs'][number]
}) => {
    const tiles = [
        {
            icon: <LocalGasStationOutlinedIcon />,
            label: estimateLeg.emissionFactor.name,
        },
        {
            icon: <OpacityOutlinedIcon />,
            label: `${requestLeg.fuelConsumedLitres} litres`,
        },
    ]
    return (
        <InputsWrapper>
            <ResultLabeledSectionAndTiles tiles={tiles} />
        </InputsWrapper>
    )
}

export default MultiLegShippingByFuelInputSection
